import React  from 'react'
import DropDown from '../dropdown';
import {StaticDiscounts} from '../../../api/services/next'

const StaticDiscountDropDown = ({...rest}) => {
    const spec = {};
    return <DropDown 
                    search
                    api={StaticDiscounts.GetStaticDiscounts} 
                    spec={spec} textField="Description" 
                    descriptionField="Code" 
                    valueField="Id"  
                    {...rest}/>
}

export default StaticDiscountDropDown

